import { STLLoader } from "three/addons/loaders/STLLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("/draco/");
// dracoLoader.setDecoderConfig({ type: "wasm" });

const stlLoader = new STLLoader();

export const _modelLoad = (fileUrl, filePath) => {
  let loader = null;

  if (filePath.endsWith(".drc")) {
    loader = dracoLoader;
  } else {
    loader = stlLoader;
  }

  return new Promise((resolve, reject) => {
    loader.load(
      fileUrl,
      (geometry) => {
        resolve(geometry);
      },
      undefined,
      (error) => {
        reject(error);
      }
    );
  });
};

const arrayBufferToDataUrl = async (arrayBuffer, mime = "application/octet-stream") => {
  const blob = new Blob([arrayBuffer], { type: mime });
  return await new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);       // "data:...;base64,..."
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

export const modelLoad = async (fileUrl, filePath) => {


  const arrayBuffer = await fileUrl.async("arraybuffer");
  const dataUrl = await arrayBufferToDataUrl(arrayBuffer);

  let loader = null;

  if (filePath.endsWith(".drc")) {
    loader = dracoLoader;
  } else {
    loader = stlLoader;
  }

  return new Promise((resolve, reject) => {
    loader.load(
      dataUrl,
      (geometry) => {
        resolve(geometry);
      },
      undefined,
      (error) => {
        reject(error);
      }
    );
  });
};
